import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Charger la table Crypto depuis l'API backend et recalculer le portfolio après chargement
fetch('/api/cryptos/all')
  .then(res => res.json())
  .then(data => {
    // Adapter le mapping selon la structure retournée par l'API
    window.cryptoTable = data.map(c => ({
      symbol: c.symbol,
      priceUsd: c.currentPrice // ou c.priceUsd selon le backend
    }));
    import('./stores/portfolioStore').then(store => {
      store.usePortfolioStore.getState().rebuildView();
    });
  });
